import script from "./index-blog.vue?vue&type=script&setup=true&lang=js"
export * from "./index-blog.vue?vue&type=script&setup=true&lang=js"

import "./index-blog.vue?vue&type=style&index=0&id=04e317ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e317ba"]])

export default __exports__